import React, { useState, useRef, useEffect } from "react"
import { graphql, navigate, Link } from "gatsby"
import { Marker, Popup } from "react-leaflet"
import Leaflet from "leaflet"
import { SearchButton } from "gatsby-theme-cactus/src/gatsby-theme-blank/components/Layout/HeaderTop/header-top-styled"
import Layout from "gatsby-theme-cactus/src/gatsby-theme-blank/components/Layout/layout"
import ContenuLibre from "gatsby-theme-cactus/src/gatsby-theme-blank/components/ContenuLibre/contenu-libre"
import {
  zoneAdressesLibreBas,
  zoneAdressesLibreHaut,
  container,
  listAdressesContainer,
  listAdressesContainerMobile,
  adressesContainerMobile,
  adressesContainer,
  adressItem,
  filterAndSearch,
  filterAndSearchContainer,
  mapContainer,
  filtersTaxo,
  filtersTaxoMobile,
  search,
  searchInputContainer,
  searchExactQuery,
  mobileIcon,
  mobileIconMobile,
  popupInfos,
} from "./styles/listAdresses.module.scss"
import PropTypes from "prop-types"
import AdressSearchResults from "gatsby-theme-blank/src/components/AdressSearch/adress-search-results"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import {
  ListContainer,
  StyledAdresseItem,
} from "gatsby-theme-blank/src/templates/list/styled-components/adresses-styled"
import SEO from "gatsby-theme-blank/src/components/seo"
import AdresseItem from "gatsby-theme-blank/src/templates/list/listItems/adresse-item"
import LeafletMap from "gatsby-theme-blank/src/components/Map/leafletmap"
import redMarker from "gatsby-theme-blank/src/components/Map/images/red-marker.png"
import { initialZoom } from "gatsby-theme-lantana/src/gatsby-theme-cactus/gatsby-theme-blank/constants"
import { isDomAvailable } from "gatsby-theme-blank/src/components/Map/lib/util"
import root from "window-or-global"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import Obfuscate from "react-obfuscate"
import { FiltreTaxo } from "gatsby-theme-blank/src/templates/list/utils/filtre-taxo"
import MarkerClusterGroup from "react-leaflet-markercluster"
import "leaflet/dist/leaflet.css"
import "react-leaflet-markercluster/dist/styles.min.css"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query {
    allTaxonomyTermThematiques(sort: { fields: name, order: ASC }) {
      edges {
        node {
          relationships {
            node__carnet_d_adresse {
              status
            }
          }
          name
          drupal_id
          relationships {
            taxonomy_term__thematiques {
              name
              drupal_id
            }
          }
        }
      }
    }
    allNodeCarnetDAdresse(sort: { fields: title, order: ASC }) {
      ...ListAdresses
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const AdressesTemplate = ({ data, location }) => {
  /**
   * mapEffect
   * @description Fires a callback once the page renders
   * @example Here this is and example of being used to zoom in and set a popup on load
   */

  const normalize = (string) => {
    return string
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
  }

  async function mapEffect({ leafletElement: map } = {}) {
    if (!map) return null
  }
  let taxoParam = null
  if (location.search !== "") {
    taxoParam = location.search.slice(location.search.lastIndexOf("=") + 1)
    if (taxoParam.includes(" ")) {
      taxoParam = taxoParam.replace(" ", "")
    }
  }
  let adresses = data.allNodeCarnetDAdresse.edges
  adresses.sort((adresse1, adresse2) =>
    normalize(adresse1.node.title) > normalize(adresse2.node.title)
      ? 1
      : normalize(adresse2.node.title) > normalize(adresse1.node.title)
      ? -1
      : 0
  )
  const allTaxoNames = data.allTaxonomyTermThematiques.edges.map(({ node }) => {
    return node.name
  })
  let relatedTaxos = data.allTaxonomyTermThematiques.edges
    .filter(({ node }) => {
      return node.relationships?.node__carnet_d_adresse?.some(
        (element) => element.status === true
      )
    })
    .map(({ node }) => {
      return {
        name: node.name,
        id: node.drupal_id,
        children: node.relationships.taxonomy_term__thematiques,
      }
    })
  const tabIdChildrenTaxos = relatedTaxos
    .map((element) => {
      if (element.children?.length > 0) {
        const tabAllChildrenId = element.children.map(
          (childTaxo) => childTaxo.drupal_id
        )
        return tabAllChildrenId
      }
      return undefined
    })
    .filter((element) => element)
    .flat()
  relatedTaxos = relatedTaxos.filter((element) => {
    if (tabIdChildrenTaxos.includes(element.id)) {
      return false
    }
    return true
  })
  const [choosenAdress, setChoosenAdress] = useState(null)
  const [choosenTaxo, setChoosenTaxo] = useState(taxoParam)
  const [choosenTaxoObject, setChoosenTaxoObject] = useState()
  const [searchQuery, setSearchQuery] = useState("")
  const [mobileArrow, setMobileArrow] = useState(false)
  const [exactQuery, setExactQuery] = useState(false)
  const [results, setResults] = useState([])
  const [childrenFinalTaxo, setChildrenFinalTaxo] = useState()
  const setChoosenTaxoFinal = (value) => {
    setChoosenTaxo(value)
  }
  const setChoosenTaxoObjectFinal = (value) => {
    setChoosenTaxoObject(value)
  }
  const setChildrenFinalTaxoFinal = (value) => {
    setChildrenFinalTaxo(value)
  }
  useEffect(() => {
    if (searchQuery && root.__LUNR__) {
      const finalSearchQuery = exactQuery
        ? `${searchQuery}`
        : `${searchQuery}^100 ${searchQuery}*^10 ${searchQuery}~2`
      root.__LUNR__.__loaded.then((lunr) => {
        const refs = lunr.fr.index.search(finalSearchQuery)
        const posts = refs.map(({ ref }) => lunr.fr.store[ref])
        setResults(posts)
      })
    }
  }, [searchQuery, exactQuery])
  const [dimensions, setDimensions] = useState({
    height: root.innerHeight,
    width: root.innerWidth,
  })
  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      setDimensions({
        height: root.innerHeight,
        width: root.innerWidth,
      })
    }, 1)

    root.addEventListener("resize", debouncedHandleResize)

    return (_element) => {
      root.removeEventListener("resize", debouncedHandleResize)
    }
  })
  const initialAdress = adresses[0]
  const markerRef = useRef(
    [...new Array(adresses.length)].map(() => React.createRef())
  )
  const [mapSettings, setMapSettings] = useState({
    center: [
      initialAdress.node.field_coordon?.lat ?? 46,
      initialAdress.node.field_coordon?.lon ?? 2,
    ],
    defaultBaseMap: "OpenStreetMap",
    zoom: initialZoom,
    mapEffect,
  })

  const ChangeMapMarkers = (adresse, ref) => {
    const correspondingMarker = ref.current
      .filter(
        (element) =>
          element?.current?.props.position[0] === adresse.field_coordon?.lat &&
          element?.current?.props.position[1] === adresse.field_coordon?.lon
      )
      .shift()
    if (correspondingMarker !== undefined && adresse.field_coordon) {
      setTimeout(() => {
        correspondingMarker.current.leafletElement.openPopup()
      }, 100)
    }
  }

  function debounce(fn, ms) {
    let timer
    return (element) => {
      clearTimeout(timer)
      timer = setTimeout((_element) => {
        timer = null
        fn.apply(this, arguments)
      }, ms)
    }
  }

  useEffect(() => {
    let finalAdress
    if (choosenAdress === null) {
      if (initialAdress) {
        finalAdress = initialAdress.node
        setChoosenAdress(initialAdress.node)
      }
    } else if (choosenTaxo !== null) {
      const listAdressesWithoutFirst = adresses.slice(1)
      if (listAdressesWithoutFirst.length > 0) {
        listAdressesWithoutFirst.some((adress) => {
          if (choosenAdress.title === adress.node.title) {
            finalAdress = choosenAdress
            return true
          }
          finalAdress = adresses[0].node
          return false
        })
      } else {
        finalAdress = adresses[0].node
      }
    } else {
      finalAdress = choosenAdress
    }
    setChoosenAdress(finalAdress)
    if (finalAdress === choosenAdress && finalAdress.field_coordon) {
      setMapSettings({
        center: [finalAdress.field_coordon.lat, finalAdress.field_coordon.lon],
        defaultBaseMap: "OpenStreetMap",
        mapEffect,
      })
    }
    ChangeMapMarkers(finalAdress, markerRef)
  }, [choosenAdress, choosenTaxo, adresses, initialAdress])

  const changeAdress = (adress, adressChoisie, title, adressInitiale) => {
    if (
      adressChoisie?.title !== title &&
      !(
        adress?.field_coordon?.lon === adressChoisie?.field_coordon?.lon &&
        adress?.field_coordon?.lat === adressChoisie?.field_coordon?.lat
      )
    ) {
      setChoosenAdress(adress)
    }
  }
  const mooveToActiveAdress = () => {
    if (typeof document !== `undefined`) {
      const activeAdress = document.querySelector("li[data-adress-active=true]")
      activeAdress.scrollIntoView({ behavior: "smooth", block: "end" })
    }
  }

  const toggleTaxo = (taxoChoisie, nameTaxo) => {
    if (taxoChoisie === nameTaxo) {
      setChoosenTaxo(null)
      navigate("/adresses")
    } else {
      setChoosenTaxo(nameTaxo.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
      navigate(
        "/adresses?mots-cles=" +
          nameTaxo.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      )
    }
  }

  let finalTaxo = null

  if (choosenTaxoObject?.children) {
    const arrayAllChildren = choosenTaxoObject.children.map(
      (element) => element.name
    )
    arrayAllChildren.push(choosenTaxoObject.name)
    finalTaxo = arrayAllChildren
  } else {
    finalTaxo = allTaxoNames
      .filter((element) => {
        if (
          element.normalize("NFD").replace(/[\u0300-\u036f]/g, "") ===
          choosenTaxo
        ) {
          return true
        }
        return false
      })
      .shift()
  }

  if (choosenTaxo !== null) {
    if (choosenTaxo.includes("%20")) {
      setChoosenTaxo(choosenTaxo.replace("%20", " "))
    }
    adresses = adresses.filter(({ node }) => {
      for (
        let cpt = 0;
        cpt < node.relationships.field_taxonomie_thematique.length;
        cpt++
      ) {
        const name = node.relationships.field_taxonomie_thematique[cpt].name
        if (childrenFinalTaxo) {
          if (childrenFinalTaxo.includes(name)) {
            return true
          }
        } else if (Array.isArray(finalTaxo)) {
          if (finalTaxo.includes(name)) {
            return true
          }
        } else if (name === finalTaxo) {
          return true
        }
      }
      return null
    })
  }

  let customIcon = null
  if (isDomAvailable()) {
    customIcon = new Leaflet.Icon({
      iconUrl: redMarker,
      iconAnchor: [19, 15],
      iconSize: [35, 35],
    })
  }

  useEffect(() => {
    if (choosenTaxo) {
      relatedTaxos.map((element) => {
        if (
          element.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "") ===
          choosenTaxo
        ) {
          setChoosenTaxoObject(element)
        }
        return null
      })
    } else {
      setChoosenTaxoObject()
    }
  }, [choosenTaxo])
  const pageTitle = "Liste des adresses"
  return (
    <Layout message={pageTitle}>
      <SEO
        title={pageTitle}
        description={
          "Dans cette page, vous découvrez le carnet d'adresses, mais aussi l'ensemble des thématiques suivantes : " +
          allTaxoNames.join()
        }
      />
      <Ariane pageName="Carnet d'adresses" isListing={true} />
      <section className={zoneAdressesLibreHaut}>
        <ContenuLibre zoneTaxoLibre="zone_carnet_d_adresse_haut" />
      </section>
      <section className={container}>
        <div className={filterAndSearchContainer}>
          <div className={filterAndSearch}>
            <div className={search}>
              <div className={searchInputContainer}>
                <input
                  type="search"
                  id="search-input-map"
                  name="keywords"
                  onChange={(element) => {
                    setSearchQuery(element.target.value)
                  }}
                  onFocus={() => {
                    if (mobileArrow === false && dimensions.width < 900) {
                      setMobileArrow(!mobileArrow)
                    }
                  }}
                  value={searchQuery}
                  placeholder="Rechercher..."
                  aria-label="Recherche"
                  title="Recherche d'adresses"
                />
                <SearchButton title={"Recherche"}>
                  <Icon icon="search" size={16} />
                </SearchButton>
              </div>
              <div className={searchExactQuery}>
                <label>
                  <input
                    name="exactQuery"
                    type="checkbox"
                    onChange={() => setExactQuery(!exactQuery)}
                  />
                  Rechercher les termes exacts
                </label>
              </div>
            </div>
            {dimensions.width < 900 ? null : (
              <ul className={filtersTaxo}>
                <FiltreTaxo
                  setChoosenTaxo={setChoosenTaxoFinal}
                  setChoosenTaxoObject={setChoosenTaxoObjectFinal}
                  setChildrenFinalTaxo={setChildrenFinalTaxoFinal}
                  choosenTaxo={choosenTaxo}
                  choosenTaxoObject={choosenTaxoObject}
                  childrenFinalTaxo={childrenFinalTaxo}
                  finalTaxo={finalTaxo}
                  relatedTaxos={relatedTaxos}
                  toggleTaxo={toggleTaxo}
                  style={{
                    border: "none",
                    cursor: "pointer",
                    margin: "0",
                    marginRight: "0.5rem",
                    padding: "0.35rem 0.75rem",
                    fontSize: "0.8rem",
                    fontWeight: "normal",
                    float: "right",
                  }}
                  mobile={false}
                  lantana={true}
                  isVisible={dimensions.width > 900}
                />
              </ul>
            )}
          </div>
        </div>
        <div className={mapContainer}>
          <ListContainer
            className={
              mobileArrow === true
                ? listAdressesContainerMobile
                : listAdressesContainer
            }
          >
            <div
              className={mobileArrow === true ? filtersTaxoMobile : filtersTaxo}
            >
              <FiltreTaxo
                setChoosenTaxo={setChoosenTaxoFinal}
                setChoosenTaxoObject={setChoosenTaxoObjectFinal}
                setChildrenFinalTaxo={setChildrenFinalTaxoFinal}
                choosenTaxo={choosenTaxo}
                choosenTaxoObject={choosenTaxoObject}
                childrenFinalTaxo={childrenFinalTaxo}
                finalTaxo={finalTaxo}
                relatedTaxos={relatedTaxos}
                toggleTaxo={toggleTaxo}
                style={{
                  border: "none",
                  cursor: "pointer",
                  margin: "0.15rem 0.25rem",
                  padding: "0rem 0.5rem",
                  fontSize: "0.8rem",
                  fontWeight: "normal",
                }}
                mobile={true}
                lantana={true}
                isVisible={dimensions.width < 900}
              />
            </div>
            <ul
              className={
                mobileArrow === true
                  ? adressesContainerMobile
                  : adressesContainer
              }
            >
              {searchQuery !== "" ? (
                results.length > 0 ? (
                  <AdressSearchResults
                    changeAdress={changeAdress}
                    choosenAdress={choosenAdress}
                    resultats={results}
                    adresses={adresses}
                    choosenTaxo={
                      childrenFinalTaxo ? childrenFinalTaxo : finalTaxo
                    }
                    initialAdress={initialAdress}
                  />
                ) : (
                  results.length === 0 && (
                    <div>Pas de résultats, veuillez modifier votre requête</div>
                  )
                )
              ) : (
                <RenderAdresses
                  initialAdress={initialAdress}
                  changeAdress={changeAdress}
                  adressesData={adresses}
                  choosenAdress={choosenAdress}
                />
              )}
            </ul>
            <div
              role="button"
              tabIndex={0}
              onClick={() => {
                setMobileArrow(!mobileArrow)
              }}
              onKeyDown={() => {
                if (event.key === "Enter") {
                  setMobileArrow(!mobileArrow)
                }
              }}
              className={mobileArrow === true ? mobileIconMobile : mobileIcon}
            >
              <Icon icon="circle-up" size={32} />
            </div>
          </ListContainer>
          {/* leaftlet map */}
          <LeafletMap
            style={{ width: "75%", height: "100%" }} // declare style attribute to avoid blank map on first render (due to load problem with leaflet-container class)
            onClick={() => {
              if (mobileArrow === true) {
                setMobileArrow(!mobileArrow)
              }
            }}
            onDrag={() => {
              if (mobileArrow === true) {
                setMobileArrow(!mobileArrow)
              }
            }}
            onZoom={() => {
              if (mobileArrow === true) {
                setMobileArrow(!mobileArrow)
              }
            }}
            {...mapSettings}
          >
            <MarkerClusterGroup>
              {adresses.map(({ node }, key) => {
                const {
                  drupal_id,
                  title,
                  path,
                  field_coordon,
                  field_adresse,
                  field_mail,
                  field_telephone,
                } = node
                if (!field_coordon) {
                  return null
                }
                const position = [field_coordon.lat, field_coordon.lon]
                return (
                  <Marker
                    onClick={() => {
                      changeAdress(node, choosenAdress, title, initialAdress)
                      mooveToActiveAdress()
                    }}
                    ref={markerRef.current[key]}
                    key={drupal_id}
                    position={position}
                    icon={customIcon}
                  >
                    <Popup className={popupInfos}>
                      <Link to={path.alias}>
                        <b>{title}</b>
                      </Link>
                      <p>{field_adresse.address_line1}</p>
                      {field_adresse.address_line2 && (
                        <p>{field_adresse.address_line2}</p>
                      )}
                      <p>{field_adresse.postal_code}</p>
                      <p>{field_adresse.locality}</p>
                      <b>
                        <Obfuscate email={field_mail} />
                      </b>
                      <br />
                      <b>
                        <Obfuscate tel={field_telephone} />
                      </b>
                    </Popup>
                  </Marker>
                )
              })}
            </MarkerClusterGroup>
          </LeafletMap>
        </div>
      </section>
      <section className={zoneAdressesLibreBas}>
        <ContenuLibre zoneTaxoLibre="zone_carnet_d_adresse_bas" />
      </section>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderAdresses = ({
  adressesData,
  changeAdress,
  choosenAdress,
  initialAdress,
}) => (
  <>
    {adressesData.map(({ node }) => {
      let active
      if (
        choosenAdress !== null &&
        choosenAdress.field_coordon?.lat === node.field_coordon?.lat &&
        choosenAdress.field_coordon?.lon === node.field_coordon?.lon
      ) {
        active = true
      } else {
        active = false
      }
      return (
        <StyledAdresseItem
          active={active}
          clickable={!!node.field_coordon}
          key={node.drupal_id}
          className={adressItem}
          data-adress-active={active}
        >
          <AdresseItem
            initialAdress={initialAdress}
            choosenAdress={choosenAdress}
            changeAdress={changeAdress}
            adress={node}
          />
        </StyledAdresseItem>
      )
    })}
  </>
)

//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

AdressesTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
RenderAdresses.propTypes = {
  adressesData: PropTypes.array.isRequired,
  changeAdress: PropTypes.func,
  choosenAdress: PropTypes.object,
  initialAdress: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default AdressesTemplate
